const ko = {
  general: {
    error: '문제가 발생했어요. ☹ 잠시 후 다시 시도해 주세요.',
    seriousError:
      '문제가 발생했어요. 잠시 후 다시 시도해 주세요. 도움이 필요하신가요? <b>support@tape.ooo</b> 로 연락 주세요.',
  },
  error: '문제가 발생했어요.',

  hello: '안녕 세상아',
  language: {
    en: 'English',
    ko: '한국어',
  },
  yes: '네',
  no: '아니요',
  cancel: '취소',
  languageMenu: '언어',
  selectDateTime: '날짜와 시간을 선택해주세요.',
  'Exit Picture-in-Picture': '소형 플레이어 종료',
  'Picture-in-Picture': '소형 플레이어',
  Replay: '다시 재생',
  or: '또는',
  success: '성공',
  signInTitle: 'Welcome to Tape 👋',
  signInContent: `We'll sign you in or create an<br />account if you don't have one yet.`,
  signInVerifyTitle: `We've sent a verification<br />code to your email 💌`,
  signInVerifyContent: 'Please check your inbox and paste<br />the verification code below.',
  signInVerifyLabel: 'Verification Code',
  signInVerifyHint: 'Enter the verification code',
  signInVerifiedTitle: `You're almost in!`,
  signInVerifiedContent: `Let your audience know who you are!`,
  signInVerifiedLabel: 'Name',
  signIn: '로그인',
  signOut: '로그아웃',
  signUp: '회원가입',
  guestSignUpTitle: 'Continue as ',
  goSignUp: '가입하기',
  tryForFree: '무료로 시작하기',
  getStarted: '지금 시작하기',
  bookDemo: '데모 예약',
  resetPassword: '비밀번호 재설정',
  changePassword: '비밀번호 변경',
  signInWithGoogle: '구글로 계속하기',
  signUpWithGoogle: '구글로 계속하기',
  msgSignInFailed: '해당 이메일/패스워드로 가입된 계정을 <br />찾지 못했어요.',
  policyText:
    'By continuing you acknowledge that you have read and<br />understood, and agree to Tapes <u><a href="https://taperlabs.notion.site/Terms-of-Service-91bdd3bad41448318c3d32d9a332b6b7" target="_blank">Terms of Service</a></u> and <u><a href="https://taperlabs.notion.site/Privacy-Policy-770ef1b2cccb4defb2c085cda5f67de8" target="_blank">Privacy Policy</a>.</u>',
  email: '이메일',
  emailAddress: '이메일 주소',
  msgEnterEmail: '이메일 주소를 입력하세요.',
  msgCheckEmailFormat: '이메일 형식을 확인해주세요.',
  msgCheckVerifyFormat: '인증코드를 확인해주세요.',
  msgEmailAlreadyInUse: '해당 이메일로 이미 가입된 계정이 있어요.',
  msgPasswordMinLength: '비밀번호는 8자리 이상으로 설정해주세요.',
  msgVerifyCodeMinLength: '회원가입 코드 6자리를 입력해주세요.',
  msgWorkspaceNameMinLength: '워크스페이스 이름은 2자리 이상으로 설정해주세요.',
  password: '비밀번호',
  msgEnterNewPassword: '새로운 비밀번호를 입력하세요.',
  msgEnterPassword: '비밀번호를 입력하세요.',
  msgWrongPassword: '정확한 비밀번호를 입력하세요.',
  verifyCode: '회원가입 코드',
  // msgEnterVerifyCode: '회원가입 코드를 입력하세요.',
  msgEnterVerifyCode: '인증코드를 입력하세요.',
  userFullName: '이름',
  msgEnterUserFullName: '이름을 입력하세요.',
  userDisplayName: '표시 이름',
  msgEnterUserDisplayName: '표시 이름을 입력하세요.',
  optional: '선택',
  continueWithEmail: '이메일로 계속하기',
  createNewAccount: '새로운 계정 생성',
  welcomeToTape: 'Tape에 오신 것을 환영해요👋',
  welcomeDesc: '시작하시려면 워크스페이스를 생성하거나 참여하세요.',
  joinOrCreateDesc: '워크스페이스에 참여하거나 생성하세요.',
  createWorkspace: '새 워크스페이스 생성',
  createWorkspaceDesc: '팀에 대한 몇 가지 정보를 입력하세요.',
  joinInvitedWorkspace: '[{wsName}] 참여',
  joinInvitedWorkspaceDesc: '워크스페이스를 확인하고 참여해주세요.',
  join: '참여하기',
  msgUserAlreadyJoined: '이미 참여한 워크스페이스입니다.',
  msgMagicLinkError: '이 링크는 이용할 수 없습니다.<br>회원님을 초대한 매니저에게 문의해주세요.',
  addLogo: '로고 추가하기',
  workspaceName: '워크스페이스 이름',
  msgEnterWsName: '워크스페이스 이름을 입력하세요.',
  workspaceDomain: '워크스페이스 도메인',
  msgEnterWsDomain: '워크스페이스 도메인을 입력하세요.',
  msgWorkspaceDomainNotAvailable: '이 도메인은 이미 존재하거나 사용할 수 없어요.',
  wsTeamType: '팀 타입',
  msgSelectWsTeamType: '팀 타입을 선택하세요.',
  inviteTeammates: '팀원을 초대하세요.',
  inviteTeammatesDesc: '끝없는 화상회의와 메신저로부터 구하고 싶은 사람들을 알려주세요👀',
  inviteTeammatesCompleteDesc: '팀원들이 곧 초대 이메일을 받게 될 거에요.',
  msgRedirectDesc: '3초 후에 워크스페이스로 이동합니다.',
  joinWorkspace: '기존 워크스페이스 참여',
  joinWorkspaceDesc: '팀 워크스페이스의 도메인을 입력하세요.',
  msgCheckWorkspaceDomain:
    '도메인 주소를 확인해주세요.<br/>Tip, 초대 이메일을 통한 참여도 가능해요.<br/>워크스페이스 관리자에게 요청해보세요.',
  continue: '계속하기',
  joinWorkspaceRequestDesc: '관리자에게 액세스 권한을 요청합니다.',
  joinWorkspaceComplete: '완료!',
  joinWorkspaceCompleteDesc: '관리자가 승인하면 이메일을 보내드릴게요.',
  sendAccessRequest: '액세스 권한 요청',
  // msgAlreadyExist: '이미 액세스 권한이 있거나 관리자의 승인을 기다리고 있습니다.',
  goToWorkspace: '워크스페이스로 가기',
  searchMeeting: '미팅 검색',
  search: '검색',
  profilePhoto: '프로필 사진',
  uploadProfilePicture: '프로필 사진 업로드',
  rename: '이름 바꾸기',
  delete: '삭제',
  share: '공유',
  end: '종료',
  ended: '종료',
  restart: '재시작',
  deleteAccount: '계정 삭제',
  deleteAccountConfirmMsg: '계정을 삭제하면 되돌릴 수 없습니다. 정말 삭제하시겠어요?',
  cannotUndoneMsg: '이 기능은 다시 되돌릴 수 없어요. 계속하시겠어요?',
  change: '수정',
  update: '수정',
  upload: '업로드',
  record: '녹화',
  text: '텍스트',
  calendly: '캘린들리',
  poll: '투표',
  vote: '투표',
  voteAgain: '투표 다시하기',
  pollDialogTitle: '투표 만들기',
  pollDialogQuestionTitle: '질문 만들기',
  pollDialogQuestionHint: '질문을 입력하세요.',
  pollDialogChoiceTitle: '아래에 선택 항목들을 입력하세요.',
  setting: '설정',
  workspaceIcon: '워크스페이스 아이콘',
  domainName: '도메인 이름',
  addMember: '팀원 추가',
  add: '추가',
  manageMembers: '멤버 관리',
  viewMembers: '멤버 보기',
  manage: '관리',
  view: '보기',
  deleteWorkspace: '워크스페이스 삭제',
  deleteWorkspaceConfirmMsg:
    '<p>이 작업은 워크스페이스 내 모든 데이터를 삭제하며, 삭제된 데이터는 다시 복원될 수 없습니다. <br><br>계속하시려면 워크스페이스 이름을 입력해주세요.<p>',
  leaveWorkspace: '워크스페이스 나가기',
  leave: '나가기',
  leaveWorkspaceConfirmMsg:
    '이 워크스페이스에서 나가시겠어요? 워크스페이스에서 나가면 Private 공간 안의 모든 미팅이 삭제돼요.',
  startMeeting: '새로운 미팅 시작',
  startConversation: '새로운 화제 시작',
  signInToSpeak: '로그인 후 답장하기',
  enterNote: '노트 입력',
  enterText: '텍스트 입력',
  enterTitle: '제목 입력',
  enterClipTitle: '클립 제목 입력',
  recordingSettings: '녹화 설정',
  audioInput: '오디오 입력',
  videoInput: '비디오 입력',
  audioPlaceHolder: '오디오 선택',
  videoPlaceHolder: '비디오 선택',
  emptyMeetingTitle: '첫번째 미팅 시작',
  emptyMeetingBody: '완전히 새로운 커뮤니케이션. <br /> 아래 버튼을 눌러 시작하세요.',
  emptyClipBody: '아직 아무도 이야기를 시작하지 않았어요. <br />가장 먼저 이야기를 시작해보세요.',
  firstMeetingTopic: "'의 새로운 미팅",
  heroPhrase0: '더 조금 만나고<br/> 더 많이 ',
  heroPhrase1: '성장하기🏋️‍♂️',
  heroDescription0: '화상회의 대신 비디오 메세징으로 시도해보세요',
  heroDescription1: ' - 아무런 설치가 필요 없어요. <br/>',
  heroDescription2: '단 몇 번의 클릭으로 내 컴퓨터 화면과 얼굴을 녹화해서 공유해보세요!',
  diffTitle0: '내 캘린더의<br />진짜 주인이 되는 방법',
  diffDescription0:
    '화상회의를 잡는 대신 작업 결과물, 피드백, 질문을 녹화해서 공유해보세요. 만나지 않고도 충분히 소통이 가능해요.',
  diffTitle1: '모든 것을 한 눈에',
  diffDescription1:
    '하나의 주제는 하나의 쓰레드로 이야기하고, 새로운 내용은 한 눈에 확인할 수 있어 메세지를 바로 확인하지 않아도 놓칠 염려가 없어요.',
  diffTitle2: '중요한 일에 집중하기',
  diffDescription2: '답변할 사람을 명확하게 지정하여, 팀원들의 집중을 깨지 않고 소통할 수 있어요.',
  usecaseTitle: '팀 커뮤니케이션을 위해 만들었어요',
  usecaseDescription:
    '사실 대부분의 팀 커뮤니케이션은 Tape에서 할 수 있어요. <br />심지어 많은 경우에 실시간 커뮤니케이션 보다 더 낫죠😎',
  usecaseDailyStandup: 'Zoom 회의 대신 비디오와 오디오를 녹화해 공유해보세요',
  usecaseFeedbackQuestion: '짧은 질문과 피드백을 위해 Zoom 회의를 잡기에는 시간이 너무 아깝죠',
  usecaseCodeReview: '커밋 메세지가 부족할 때는 비디오를 사용해보세요',
  usecaseProjectUpdate: '팀원 모두에게 업데이트를 공유하세요. 일정 조율이 없다면 쉽게 할 수 있죠',
  usecaseWebinar: '새벽 3시에 일어나 참석하지 않아도 질문을 할 수 있는 웨비나를 상상해보세요',
  usecaseEtc: 'Tape이 여러분의 업무를 더 효율적으로 만들 수 있는 방법을 계속 알려드릴게요👀',
  termsOfService: '<a href="https://taperlabs.notion.site/b8e7494516914aba8f12782c3a92ddc3">Terms of Service</a>',
  privacyPolicy: '<a href="https://taperlabs.notion.site/f348bcefbed04f5d9b3196a3a04e732c">Privacy Policy</a>',
  confirm: '확인',
  confirmMsg: '이 작업은 되돌릴 수 없습니다.',
  updateSuccess: '성공적으로 업데이트 되었습니다.',
  updateFail: '업로드 실패 : ',
  workingFeatureMsg:
    '이 기능은 아직 준비 중 입니다. 하루 빨리 기능을 제공하려고 열심히 준비 중이니 조금만 기다려주세요.🙇‍♀️',
  noAccessMsg: '접근 권한이 없습니다.<br />관리자에게 멤버 초대를 요청하세요.',
  channelNoAccess1: 'This link is currently disabled. ️🙁',
  channelNoAccess2: 'Please contact the owner and ask enable it again.',
  notSupportedEnvMsgMobile:
    '죄송해요.🙇‍♀️ 아직 모바일 브라우저는 지원되지 않아요. 열심히 만들고 있으니 조금만 기다려 주세요! <br /> Tape은 PC/Mac 환경에서 Chrome 또는 Edge 브라우저에서 가장 잘 동작해요.',
  notSupportedEnvMsg:
    '죄송해요.🙇‍♀️ 현재 접속하신 브라우저는 아직 지원되지 않아요. Tape은 PC/Mac 환경에서 Chrome 또는 Edge 브라우저에서 가장 잘 동작해요.',
  recordingNotSupportedMsg:
    '죄송해요.🙇‍♀️ 현재 브라우저는 녹화 기능을 제공하지 않아요. Tape은 PC/Mac 환경에서 Chrome 또는 Edge 브라우저에서 가장 잘 동작해요.',
  notAvailableFeatureMsg: '죄송해요.🙇‍♀️ 현재 이 기능은 준비 중에 있어요. 열심히 만들고 있으니 조금만 기다려 주세요!',
  notAvailableFeatureImporatantMsg:
    '죄송해요.🙇‍♀️ 현재 이 기능은 준비 중에 있어요. 열심히 만들고 있으니 조금만 기다려 주세요! 혹시 도움이 필요하신가요? support@tape.ooo로 연락주세요🙋‍♀️ ',
  recordFailMsg:
    '🙇🏻‍♂️ We are sorry. Recording has just force stopped due to browser error. Will you give us second chance? 🥺',
  reload: 'Reload',
  shareMeetingTitle: '미팅 공유',
  deleteCurrentClip: '현재 클립 삭제',
  deleteMeeting: '미팅 삭제',
  deleteComment: '댓글 삭제',
  deleteMeetingContent: '이 작업은 취소할 수 없어요. 미팅의 모든 클립을 영구적으로 삭제해요.',
  deleteCancel: '취소',
  deleteClipSuccess: '클립이 삭제되었어요',
  deleteMeetingSuccess: '미팅이 삭제되었어요',
  deleteCommentSuccess: '댓글이 삭제되었어요',
  deleteSection: '섹션 삭제',
  deleteSectionContent: '이 작업은 취소할 수 없어요. 섹션의 모든 클립을 영구적으로 삭제해요.',
  deleteSectionSuccess: '섹션이 삭제되었어요',
  noClipToDelete: '삭제할 클립이 없습니다.',
  alreadyDeleted: '이미 삭제되었습니다.',
  completedAcceptJoinWs: '워크스페이스 가입 수락을 완료 했습니다.',
  notManagerErrorMsg: 'We are sorry. You are not authorized to grant this request.',
  invitedWorkspace: '초대된 워크스페이스',
  successUpdateMemberType: '멤버 타입이 변경되었습니다.',
  browserAccessPermission: '녹화를 위해서는 카메라와 마이크 권한 허용이 필요해요.',
  systemDenied: '시스템 권한이 필요해요.',
  notReadableError: '스크린 공유가 불가능해요. 브라우저를 재시작 후 다시 시도해 주세요.',
  sendResetPassWord: '비밀번호 재설정 이메일이 곧 도착할거에요.',
  setClipFail: '파일 생성중 오류가 발생했습니다. 지속되면 support@tape.ooo로 연락주세요🙋‍♀️',
  setSubTitleFail: '자막 업로드중 오류가 발생했습니다. 지속되면 support@tape.ooo로 연락주세요🙋‍♀️',
  subtitleAlreadyExist: 'A subtitle for the selected language already exists. Please delete it and try again.',
  uploadSubtitleSuccess: '자막 업로드 성공',
  openSubtitleDialogError: 'Subtitle can only be uploaded by the clip uploader or the meeting organizer.',
  inputStringErr: '다시 입력해 주세요.',
  deviceNotFound: '녹화에 사용할 수 있는 장치가 없습니다.',
  moveToMeetingTitle: '미팅 이동',
  joinOrCreateWorkspace: '+ 워크스페이스 가입 또는 생성',
  wsNotExistMsg: '앗, 여긴 아무것도 없어요 👀',
  eMailNotificationSetting: '이메일 알림',
  copiedClipboardUrl: 'URL이 클립보드에 복사되었어요.',
  copiedClipboardText: '내용이 클립보드에 복사되었어요.',
  failedCopy: '복사에 실패했습니다. 다시 시도해주세요.',
  textRecordTitle: '어떤 내용을 공유할까요?',
  notiCreateMt: '<b>%s</b>님이 <b>%s</b> 미팅을 생성했어요.',
  notiCreateClip: '<b>%s</b>님이 <b>%s</b> 미팅에 클립을 업로드했어요.',
  notiWatchedClip: '<b>%s</b>님이 <b>%s</b> 미팅의 클립을 시청했어요.',
  notiRequestFollowUp: '<b>%s</b>님에게 <b>%s</b> 미팅의 답변이 요청되었어요.',
  notiAnHour: '<b>%s</b> have a request due in 1 hour - <b>%s</b>',
  notiExpiration: 'Complete your follow up request - <b>%s</b>',
  notiResponseFollowUp: '<b>%s</b>님이 <b>%s</b> 미팅에 답변을 예약했어요.',
  notiRequestFollowUpTitle: 'is requested to respond.',
  notiMention: '<b>%s</b>님이 <b>%s</b>에서 나를 멘션했어요.',
  notiCreateComment: '<b>%s</b>님이 <b>%s</b> 댓글을 <b>%s</b> 에 남겼어요.',
  noNotification: '알림이 없어요 👀',
  reservedClipAlert: '님이 곧 답변할 예정이에요.</br>무시하고 답변하시겠어요?👀',
  reservedClipRequested: '님에게 답변이 요청됨',
  reservedClipWill: '님이 답변할 예정',
  recordNow: '녹화하기',
  requestResponse: '답변 요청',
  requestSubTitle: 'Who would you like to request a response from?',
  willFollowUp: '답변 예약',
  request: '요청',
  skip: '생략',
  done: '완료',
  addDueDate: '일정을 추가하세요',
  tags: '태그',
  addTags: '태그 추가 +',
  viewers: '시청자',
  noOneWatched: '시청자가 없어요.',
  privateOnBoardingTitleGreeting: '%s님 안녕하세요',
  privateOnBoardingTitleDescription: ', 이곳은 개인 작업 공간이에요',
  privateOnBoardingBody:
    '이 곳에 있는 미팅들은 내가 공유 설정에서 링크 공유를 허용하기 전까지 나만 볼 수 있어요. 팀원이 아닌 사람들에게 메세지를 전달할 때 사용해보세요!',
  privateOnBoardingStep1Title: '1단계 - 미팅 시작하기',
  privateOnBoardingStep1Description0: '미팅을 생성해 짧은 비디오 메세지를 주고 받을 수 있어요.',
  privateOnBoardingStep1Description1: '모든 메세지는 하나의 쓰레드로 저장되죠🌈',
  privateOnBoardingStep1Description2: '화면 아래 버튼을 눌러 미팅을 시작해보세요👇',
  privateOnBoardingStep2Title: '2단계 - 공유하기',
  privateOnBoardingStep2Description0:
    '미팅 화면 오른쪽 위에 있는 "Share" 버튼을 눌러 외부 접근 허용 후 링크🔗를 통해 공유할 수 있어요.',
  privateOnBoardingStep3Title: '3단계 - 답변 기다리기',
  privateOnBoardingStep3Description0: '완료! 답장이 오면 이메일📧로 알려드릴게요.',
  workspaceOnBoardingTitleDescription: '이곳은 팀 워크스페이스에요',
  workspaceOnBoardingBody: '이 곳의 미팅은 팀원 모두가 볼 수 있어요. 더 빠르고 편리하게 팀원들과 소통해보세요!',
  workspaceOnBoardingStep1Title: '1단계 - 팀원 추가하기',
  workspaceOnBoardingStep1Description0:
    '워크스페이스를 생성한 팀원 또는 매니저는 팀원들을 워크스페이스로 초대할 수 있어요. 팀원들을 초대해 더 편리하게 소통해보세요.',
  workspaceOnBoardingStep2Title: '2단계 - 미팅 시작하기',
  workspaceOnBoardingStep2Description0:
    '화면 아래 버튼을 눌러 미팅을 시작하고 비디오 메세지를 녹화해보세요👇 아니면, 이야기를 했으면 하는 팀원을 지정할 수도 있어요👀',
  workspaceOnBoardingStep3Title: '3단계 - 답변 기다리기',
  workspaceOnBoardingStep3Description0: '완료! 팀원들 중 누군가 답을 올리면 이메일📧로 알려드릴게요.',
  onboardingGetStarted: '시작해볼까요?',
  noMsg: '아직 메세지가 없어요',
  noMsgToDo: '메세지를 녹화하거나 답변을 요청해보세요.',
  noMsgToDoDetail: '화면 아래에 녹화 버튼🔴을 눌러 녹화를 시작하세요',
  noMsgVideoTopicTitle: 'Learn about Topic based Template',
  noMsgVideoChronologicalTitle: 'Learn about Chronological Template',
  clickToStartRecording: '클릭해서 녹화하기',
  titleEmpty: 'No clips yet',
  titleLast: 'Add a new clip',
  msgEmpty: `Start recording meetings or updates by either pressing the 'Record Now' button below or pressing`,
  finish: '완료',
  retry: '재시도',
  progressUploadingTitle: '탭을 종료하거나 새로고침을 하면 안돼요🖐',
  progressCompleteTitle: '완료 ✅',
  failedUploadTitle: '업로드에 실패했습니다😥 다시 시도 하실래요?',
  failedUploadSubTitle: '향후 개선할게요!',
  discard: '취소',
  inbox: 'Inbox',
  inboxEmpty: '수신함에 미팅이 없어요',
  assignedToMe: 'Assigned To Me',
  assignedSubTitle: 'Your Follow Up',
  assignedEmpty: 'All clear. Nothing to follow up💪',
  copyLinkUrl: '미팅 URL 복사',
  msgIncorrectCode: '잘못된 인증코드에요.',
  msgSendVerifyCodeInfo: '임시 회원가입 코드를 보냈어요. 받은 편지함을 확인 후 아래에 코드를 붙여넣으세요.',
  notiPrefAlways: '모든 알림',
  notiPrefRequested: '내게 답변 요청이 있을 때만',
  notiPrefNever: '받지 않음',
  remindContent: '정말 삭제할까요?',
  magicLinkTitle: '%s에 있는 팀에 참여하기',
  magicLinkContent: '%s님이 새 Tape 워크스페이스 %s를 생성했습니다. 링크를 클릭해 참여하세요!',
  fileUploadTitle: '비디오 업로드',
  subTitleUploadTitle: '자막 업로드',
  selectSubTitleFileTitle: '자막 파일 선택',
  selectSubTitleLanguageTitle: '언어 선택',
  fileUploadContent: '여기에 파일을 드래그로 업로드하세요.',
  fileUploadContent2: '* MP4 (H.264) 파일을 업로드 할 수 있어요.',
  subTitleUploadContent: '* .srt/.vtt 파일을 업로드 할 수 있어요.',
  fileUploadBtn: '파일 찾기',
  fileUploadFailed: '이 파일은 Tape에 업로드 할 수 없어요.',
  fileUploadChecking: '비디오 확인중 ...',
  subTitleUploadChecking: '자막 확인중 ...',
  onlyOneVideo: '한번에 하나의 파일만 업로드 가능해요.',
  onlySrtFile: 'srt/vtt 파일만 업로드 가능해요.',
  onlyMp4Video: 'mp4 파일만 업로드 가능해요.',
  fileSizeError: '비디오 크기는 2GB 이하로만 업로드 가능해요.',
  codecError: '이 비디오는 업로드 할 수 없습니다.',
  addNewSection: '섹션 추가',
  selectTemplateTitle: 'How would you like to organize your meeting?',
  next: '다음',
  enterSectionTitle: '섹션 제목 입력',
  selectSectionTitle: '섹션 선택',
  createSectionTitle: '새로운 섹션 만들기',
  post: '전송',
  save: '저장',
  comment: 'Comment',
  transcript: 'Transcript',
  translate: '번역',
  summary: 'Summary',
  followUpAlreadyExsit: '님이 곧 답변할 예정이에요.👀',
  download: '다운로드',
  notiEndedMeeting: '이 미팅은 종료되었어요.',
  notEnoughStorage: 'Not enough storage space',
  unTitledSection: 'Untitled Section',
  preferenceDialogTitle: `Can't share your`,
  preferenceDialogContent: `Your browser might not have %s
  permission on your computer. Go to`,
  preferenceDialogContentLink: 'System Preferences.',
  recipient: 'Recipient',
  requestContentTitle: 'What would you like to hear about?',
  enterTopicHint: 'Enter Topic',
  dueDate: 'Due Date',
  selectDateHint: 'Click here to add due date',
  requestedBy: 'By',
  about: 'About',
  joinTheWorkspaceFirstMsg: 'Join the workspace first to request a response.',
  requestResponseTitle: 'Are you ready to respond?',
  requestToMeTitle: 'Record Now',
  videoNotConvertedYet: 'The video is not ready to download just yet.😞 Please try again in a moment.',
  editName: '이름 변경',
  chNotExist: '채널이 존재하지 않습니다.',
  chMtLoadFailed: '채널 미팅 로드에 실패했습니다. 다시 시도해주세요.',
  addChannelFailed: '채널 추가에 실패했습니다. 다시 시도해주세요.',
  addChannelSuccess: '채널이 추가되었어요',
  renamePlaceholder: '채널 이름을 입력해주세요.',
  renameChannelLengthError: '채널 이름은 1자 이상 입력되어야 합니다.',
  renameChannelSameError: '중복된 채널 이름이 존재합니다. 다른 이름을 입력해주세요.',
  renameChannelFailed: '채널 이름 변경에 실패했습니다. 다시 시도해주세요.',
  renameChannelSuccess: '채널 이름이 변경되었어요',
  deleteChannel: '채널 삭제',
  deleteChannelContent: '이 작업은 취소할 수 없어요. 채널의 모든 미팅을 영구적으로 삭제해요.',
  deleteChannelFailed: '채널 삭제에 실패했습니다. 다시 시도해주세요.',
  deleteChannelSuccess: '채널이 삭제되었어요',
  deleteCommentFailed: '댓글 삭제에 실패했습니다. 다시 시도해주세요.',
  setEmojiError: '이모지를 그릴 수 없습니다.',
  deleteEmojiError: '이모지를 삭제할 수 없습니다.',
  audioDeviceNotFoundError: '사용 가능한 오디오 장치가 없어요.',
  videoDeviceNotFoundError: '사용 가능한 비디오 장치가 없어요.',
  noAudioDetectedNoti: `We're not detecting much sound from your mic. Please check your mic before recording.`,
  noAudioDetectedConfirm: `We're not detecting much sound from your mic.<br />Would you still like to continue?`,
  receivingSettingTitle: 'Receiving Setting',
  channelIconSettingTitle: 'Upload a photo',
  teamChannelTitle: 'Team Channels',
  videoNotUploaded:
    'The video is being prepared for the best watching experience.<br />Please come check again in a minute 🙏🏻',
  invalidVideo: 'Oops, we need just a little more time 😅',
  videoUploadCheck: 'Check Again Now',
  videoNotFound: 'Video Not Found 😕',
  clipUploadingError: `A video is currently being uploaded. Please try again when it's done.`,
  paymentSuccessfulMsgTitle: 'Thank you! 🙏🏻',
  paymentSuccessfulMsgContent: 'You are all set!',
  paymentResultbtnMsg: 'Go back to my workspace',
  payAnnuallyInfo: 'When you pay annually',
  plusDescriptionContent1: 'Unlimited Minutes',
  // plusDescriptionContent2: '60 min / Video',
  plusDescriptionContent3: 'Premium Features',
  plusDescriptionContent4: '(Video Upload and more)',
  freeDescriptionContent1: 'Up to 180 Minutes',
  freeDescriptionContent2: '5 min / Video',
  freeDescriptionContent3: 'Basic Features',
  freeDescriptionContent4: '(Unlimited comments and more)',
  emailAdminUpgrade: 'We will send an email to the admin to let you know that you need an upgrade.',
  beforeLeaveChangePlanMsg:
    'To leave this workspace, please downgrade your plan first. You can ask the admin or contact us.',
  beforeDeleteChangePlanMsg: 'To delete workspace, please cancel Plus plan first. ',
  needToRecordVideoLonger: 'Need to record video longer?',
  joinTheWorkspaceToRecordLongerVideo: 'Join the workspace to record longer video.',
  LearnMore: 'Learn More',
  SendRequest: 'Send a Request',
  later: 'Later',
  upgrade: 'Upgrade',
  askAdmin: 'Ask Admin',
  requestAdmin: 'Request Admin',
  askAdminInfo: 'To change plan, please contact the admin of your workspace',
  seeFeatureBenefit: 'See all features and benefits',
  changePlan: 'Change Plan',
  markAllasPlus: 'Mark All as Plus',
  summaryOfChanges: 'Summary of changes',
  yourPlan: 'Your Plan',
  billing: 'Billing',
  billingInfo: 'To make changes on payment method, view invoice history, or cancel plan, visit our customer portal.',
  openCustomerPortal: 'Open Customer Portal',
  openCustomerPortalErrMsg: 'Upgrade your plan to access the customer portal!',
  tooltipQuickRecord: 'This will create a Meeting in "My Meetings" channel.',
  linkWithGoogleError: 'Please use the same email.',
  transcriptUpgradePlan: 'Upgrade to use feature.',
  transcriptLoadingTitle: '🤖 Our AI engine is generating your transcript.',
  transcriptLoadingContent: 'You will be able to view it here shortly. Hold tight!',
  transcriptFailContent: `We couldn't detect any audible speech in this clip. 😯`,
  transcriptUncheckedOrTooShortContent: `The transcription for this clip has been turned off.`,

  summaryUpgradePlan: 'Upgrade to use summarization feature.',
  summaryLoadingTitle: 'Summarizing your video 🤖',
  summaryLoadingContent: 'Our AI engine is currently processing your video. Please give us a moment!',
  summaryFailContent: `Tape couldn't generate summary from this clip. 😯`,
  summaryUncheckedOrTooShortContent: `The summarization for this clip has been turned off.`,

  noSegments: 'Nothing to show 😰',
  copy: '복사',
  edit: '수정',
  chooseTemplateTitle: '템플릿 선택',
  chooseTemplateSubTitle:
    'Choosing a template helps our AI engine in generating a more accurate summary of your video.',
  templateBtnCustom: '커스텀',
  templateBtnNone: '없음',
  templateBtnMeetingSummary: '미팅 요약',
  templateBtnProjectUpdate: '프로젝트 업데이트',
  templateBtnBugreport: '버그 리포트',
  templateBtnProductdemo: '제품 데모',
  regenerate: 'Regenerate',
  export: 'Export',
  msgSummaryEmphasis: '🪄 Choosing a template will significantly improve the summarization quality.',
}

export default ko
